"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteSectionSubtotal = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var useQuoteLabel_1 = require("@CommonFrontend/Quote/useQuoteLabel");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var useQuoteCurrencyFormatter_1 = require("@CommonFrontendBackend/QuoteWidgets/useQuoteCurrencyFormatter");
var getOrderedTotalBreakdown_1 = require("@CommonFrontend/Quote/getOrderedTotalBreakdown");
var QuoteSectionSubtotal = function (_a) {
    var price = _a.price;
    var getLabel = (0, useQuoteLabel_1.useQuoteLabel)();
    var quoteCurrencyFormatter = (0, useQuoteCurrencyFormatter_1.useQuoteCurrencyFormatter)();
    var orderedPrice = (0, getOrderedTotalBreakdown_1.getOrderedTotalBreakdown)(price);
    var oneOffLabel = orderedPrice.length === 1 ? getLabel(Types_1.QuoteLabel.SubTotal) : getLabel(Types_1.QuoteLabel.OneOff);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "s", align: "center", wrap: true }, orderedPrice.map(function (_a, index) {
        var frequency = _a.frequency, breakdown = _a.breakdown;
        var frequencyLabel = frequency === "one-off"
            ? oneOffLabel
            : getLabel((0, Recurrence_1.mapRecurringFrequencyToAdjectiveLabel)(frequency));
        return (react_1.default.createElement(react_1.Fragment, { key: frequency },
            index > 0 && react_1.default.createElement(kaleidoscope_1.Separator, { direction: "vertical", size: tokens_1.tokens.spacing.xxl }),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", align: "end" },
                react_1.default.createElement(kaleidoscope_1.Text, { secondary: true },
                    frequencyLabel,
                    renderDiscountStrikethrough(breakdown, quoteCurrencyFormatter)),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "l" }, quoteCurrencyFormatter.format(breakdown.quoted)))));
    })));
};
exports.QuoteSectionSubtotal = QuoteSectionSubtotal;
function renderDiscountStrikethrough(breakdown, quoteCurrencyFormatter) {
    var hasSelfDiscounts = breakdown.discounts.some(function (discount) { return discount.target === "self"; });
    if (!hasSelfDiscounts)
        return "";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        react_1.default.createElement("span", { style: { textDecoration: "line-through" } }, quoteCurrencyFormatter.format(breakdown.base))));
}
